import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'username',
})
export class UsernamePipe implements PipeTransform {
  transform(body: string): string {
    const regexPattern = /\[\:\:[^\]]*\:\]/g;
    const groups = body.match(regexPattern);
    groups?.forEach((item) => {
      if (item.substr(0, 4) === '[::@') {
        const bodyParts = item.split('::]');
        const nameParts = bodyParts[0].split('::');
        const username = nameParts[1];
        const tbody = bodyParts[1];

        const transformedItem = `<span class="atMention">${username}</span>`;
        body = body.replace(item, transformedItem);
      }
    });
    return body;
  }
}
